import "./CartItem.css";
import { motion, AnimatePresence } from "framer-motion"; // Aggiunto AnimatePresence per l'animazione del popup (opzionale, ma bello)
import { useState } from "react";

const CartItem = ({ id, item, onRemove, handleAmountChange }) => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false); // Stato per il popup
    
    // --- LOGICA SCONTO ---
    const price = parseFloat(item.price);
    const salePrice = item.sale_price ? parseFloat(item.sale_price) : null;
    const isOnSale = salePrice !== null && salePrice < price;
    const discountPercentage = isOnSale ? Math.round(((price - salePrice) / price) * 100) : 0;
    const selectedSize = item.selectedSize || item.options?.selectedSize;
    // ---------------------

    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    };

    const extractImages = (data) => {
        const images = [];
        const CDN = "https://cdn.psicopaticiservice.com/";
        const main = data?.options?.image;
        if (main && !["null", "undefined"].includes(String(main))) {
            images.push(CDN + main);
        }

        const optCart = data?.options?.options?.optionCartValue;
        if (optCart) {
            if (Array.isArray(optCart)) {
                optCart.forEach((container) => {
                    Object.values(container).forEach((optionArray) => {
                        optionArray.forEach((option) => {
                            const img = option?.image;
                            if (img && !["null", "undefined"].includes(String(img))) {
                                images.push(CDN + img);
                            }
                        });
                    });
                });
            } else {
                Object.values(optCart).reverse().forEach((optionArray) => {
                    optionArray.forEach((option) => {
                        const img = option?.image;
                        if (img && !["null", "undefined"].includes(String(img))) {
                            images.push(CDN + img);
                        }
                    });
                });
            }
        }
        return images;
    };

    const extractOptions = (data) => {
        const optionsList = [];
        
        const baseValue = data?.options?.base?.value;
        const baseName = data?.options?.base?.name || "Base";
        if (baseValue) {
            optionsList.push({ name: baseName.split("-")[0].trim(), value: baseValue });
        }

        if (data?.selectedSize) {
            optionsList.push({ name: "Taglia", value: data.selectedSize });
        } else if (data?.options?.selectedSize) {
            optionsList.push({ name: "Taglia", value: data.options.selectedSize });
        }

        const info = data?.options?.options?.optionInfo;
        const cart = data?.options?.options?.optionCartValue;
        const baseOptId = data?.options?.base?.option_id;

        if (info && cart) {
            Object.entries(info).forEach(([optId, optionName]) => {
                if (baseOptId != null && String(optId) === String(baseOptId)) return;
                
                let valueFound = null;
                if (Array.isArray(cart)) {
                    const container = cart.find(obj => obj[optId]);
                    if (container && container[optId]) {
                        valueFound = container[optId][0]?.option_value;
                    }
                } else if (cart[optId]) {
                    valueFound = cart[optId][0]?.option_value;
                }

                if (valueFound) {
                    optionsList.push({ 
                        name: optionName.split("-")[0].trim(), 
                        value: valueFound 
                    });
                }
            });
        }
        return optionsList;
    };

    return (
        // Aggiunto position: relative per posizionare l'icona cestino
        <div className={"cart-card mb-4"} style={{ position: 'relative' }}>
            
            {/* --- ICONA CESTINO (Nuova implementazione) --- */}
            <button 
                onClick={() => setShowConfirm(true)}
                className="btn-trash"
                style={{
                    position: 'absolute',
                    top: '0px',
                    left: '0px',
                    background: 'transparent',
                    border: 'none',
                    color: '#dc3545', // Rosso Bootstrap
                    fontSize: '1.2rem',
                    zIndex: 10,
                    cursor: 'pointer'
                }}
                title="Rimuovi articolo"
            >
                <i className="fa-solid fa-trash"></i>
            </button>
            {/* --------------------------------------------- */}

            <div className="row g-3 mt-0">
                <div className={"relative col-5 mt-0 ps-0"} style={{ position: 'relative' }}>
                    {extractImages(item).map((img, index) => (
                        <img
                            key={index}
                            src={img}
                            alt={`img-${index}`}
                            className="cart-image"
                            style={{ zIndex: index }}
                        />
                    ))}
                </div>

                <div className={"col-7 mt-0 pe-0"} style={{ height: "15vh", overflowY: "auto", paddingRight: "30px" }}> 
                    {/* Aggiunto paddingRight per evitare che il testo vada sotto l'icona cestino */}
                    
                    <h2 className="fw-bold me-0 mt-0" style={{ fontSize: '1.2rem' }}>{item.name}</h2>
                    
                    <div className="d-flex align-items-baseline gap-2 mt-1">
                        {isOnSale ? (
                            <>
                                <p className={"price fw-bold mb-0"} style={{ color: 'black' }}>
                                    {salePrice.toFixed(2)}€
                                </p>
                                <div className="d-flex gap-1 align-items-center">
                                    <p className={"text-muted mb-0"} style={{ textDecoration: 'line-through', fontSize: '0.85rem' }}>
                                        {price.toFixed(2)}€
                                    </p>
                                    <div style={{
                                        backgroundColor: 'black',
                                        color: 'white',
                                        padding: '0px 6px',
                                        fontSize: '10px',
                                        fontWeight: 'bold',
                                        borderRadius: '2px',
                                        zIndex: 10
                                    }}>
                                        -{discountPercentage}%
                                    </div>
                                </div>
                            </>
                        ) : (
                            <p className={"price fw-bold mb-0"}>{price.toFixed(2)}€</p>
                        )}
                    </div>

                    {selectedSize && (
                        <p className="mb-0 mt-1" style={{ fontSize: '0.95rem', fontWeight: 700, color: '#111' }}>
                            Taglia: {selectedSize}
                        </p>
                    )}

                    <div>
                        <div className="mt-2 d-flex align-items-center gap-2" onClick={toggleCollapse} style={{ cursor: 'pointer' }}>
                            <p style={{ marginBottom: "0", fontSize: '0.9rem' }}>Più informazioni</p>
                            <motion.p
                                animate={{ rotate: isCollapsed ? 180 : 0 }}
                                transition={{ duration: 0.3 }}
                                style={{ display: 'inline-block', fontSize: "18px", marginBottom: "0" }}
                            >
                                <i className="fa-solid fa-caret-down"></i>
                            </motion.p>
                        </div>

                        <motion.div
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: isCollapsed ? "auto" : 0, opacity: isCollapsed ? 1 : 0 }}
                            transition={{ duration: 0.4, ease: "easeInOut" }}
                            style={{ overflow: "hidden" }}
                        >
                            <ul className="list-unstyled text-muted mt-2 mb-2">
                                {extractOptions(item).map((obj, index) => (
                                    <li key={index}>
                                        <p className="mb-0 lista" style={{ fontSize: '0.85rem' }}>• {obj.name}: {obj.value}</p>
                                    </li>
                                ))}
                            </ul>
                        </motion.div>
                    </div>
                </div>
            </div>

            {/* --- MODAL / POPUP DI CONFERMA --- */}
            {showConfirm && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 9999
                }} onClick={() => setShowConfirm(false)}>
                    <motion.div 
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        onClick={(e) => e.stopPropagation()} // Evita chiusura se si clicca dentro il box
                        style={{
                            backgroundColor: 'white',
                            padding: '20px',
                            borderRadius: '10px',
                            boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
                            maxWidth: '300px',
                            textAlign: 'center'
                        }}
                    >
                        <h5 className="fw-bold mb-3">Rimuovere articolo?</h5>
                        <p className="text-muted mb-4" style={{fontSize: '0.9rem'}}>Sei sicuro di voler eliminare "{item.name}" dal carrello?</p>
                        
                        <div className="d-flex justify-content-center gap-2">
                            <button 
                                className="btn btn-outline-secondary btn-sm"
                                onClick={() => setShowConfirm(false)}
                            >
                                Annulla
                            </button>
                            <button 
                                className="btn btn-danger btn-sm"
                                onClick={() => {
                                    onRemove(item.id);
                                    setShowConfirm(false);
                                }}
                            >
                                Elimina
                            </button>
                        </div>
                    </motion.div>
                </div>
            )}
            {/* ---------------------------------- */}
        </div>
    );
};

export default CartItem;
